import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, Typography, List, ListItem, ListItemText, Divider, Box
} from '@mui/material';
import SidelinedIcon, { getSidelinedLabel } from './SidelinedIcon';

function PlayerDetailsModal({ player, status = null, open, onClose }) {
    if (!player) return null;

    const pointsArray = Object.entries(player.points);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>{player.name} - Puntenoverzicht</DialogTitle>
            <DialogContent>
                {status && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                        <SidelinedIcon status={status} />
                        <Typography variant="body2" sx={{ color: '#e53935', fontWeight: 'bold' }}>
                            {getSidelinedLabel(status)}
                        </Typography>
                    </Box>
                )}
                {pointsArray.length > 0 ? (
                    <List>
                        {pointsArray.map(([round, score], index) => (
                            <React.Fragment key={round}>
                                <ListItem>
                                    <ListItemText
                                        primary={`Speelronde ${round.replace('round', '')}`}
                                        secondary={`${score} punten`}
                                    />
                                </ListItem>
                                {index < pointsArray.length - 1 && <Divider />}
                            </React.Fragment>
                        ))}
                    </List>
                ) : (
                    <Typography>Nog geen punten gescoord in dit toernooi.</Typography>
                )}
            </DialogContent>
        </Dialog>
    );
}

export default PlayerDetailsModal;
